import React, { useState, useEffect } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import classNames from "classnames";
import * as c from "./pageHeader.module.scss";
import { BREAKPOINTS } from "@utils/breakpoints";
import StaticGradient from "@components/shared/staticGradient";
import PageHeaderContent from "@components/shared/pageHeader/pageHeaderContent";
import PageHeaderImagesSection from "@components/shared/pageHeader/pageHeaderImagesSection";
import PageHeaderWaveBackground from "@components/shared/pageHeader/pageHeaderWaveBackground";

export const PageHeader = ({
  className,
  includeWave = true,
  includeGradient = true,
  isFeaturePage,
  isShowcasePage,
  isPaymentsPage,
  isDirectMailPage,
  pageHeaderData,
  currentImages,
}) => {
  const { label, darkBackground } = pageHeaderData;
  const { background, backgroundMobile, backgroundTablet, backgroundColor } = currentImages || {};
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const checkWidth = () => {
      setIsTablet(window.innerWidth <= BREAKPOINTS.lg && window.innerWidth > BREAKPOINTS.sm);
      setIsMobile(window.innerWidth <= BREAKPOINTS.sm);
    };

    checkWidth();

    window.addEventListener("resize", checkWidth);

    return () => {
      window.removeEventListener("resize", checkWidth);
    };
  }, []);

  return (
    <div
      className={classNames(
        c.background,
        background && c.overlay,
        darkBackground && c.dark,
        backgroundColor?.value && background && c.customBg,
        isDirectMailPage && c.directMail
      )}
      style={{
        background: backgroundColor?.value ? backgroundColor?.value : "none",
        "--bgColor": backgroundColor?.value || "none",
      }}
    >
      {background && !isTablet && !isMobile && (
        <GatsbyImage
          image={getImage(background)}
          className={classNames(c.bg, c.backgroundImage)}
          loading="eager"
          alt={label ? `${label} - Background image` : "Background image"}
        />
      )}

      {backgroundTablet && isTablet && (
        <GatsbyImage
          image={getImage(backgroundTablet)}
          className={classNames(c.bg, c.backgroundImageTablet)}
          loading="eager"
          alt={label ? `${label} - Tablet Background image` : "Tablet Background image"}
        />
      )}

      {backgroundMobile && isMobile && (
        <GatsbyImage
          image={getImage(backgroundMobile)}
          className={classNames(c.bg, c.backgroundImageMobile)}
          loading="eager"
          alt={label ? `${label} - Mobile Background image` : "Mobile Background image"}
        />
      )}

      {!background && includeGradient && !darkBackground && !isDirectMailPage && (
        <StaticGradient
          opacity="0.45"
          top="-100px"
          mask="linear-gradient(to bottom, #000 0%, transparent 100%)"
          height="50%"
        />
      )}

      <section className={classNames(className, c.container, includeWave && c.landingWrap)}>
        <div
          className={classNames(
            isFeaturePage || isShowcasePage ? c.featurePageRow : c.landingPageRow,
            !background && isDirectMailPage
          )}
        >
          <PageHeaderContent
            isFeaturePage={isFeaturePage}
            isShowcasePage={isShowcasePage}
            isDirectMailPage={isDirectMailPage}
            className={classNames(
              isDirectMailPage ? c.directMailHeader : undefined,
              background && c.oneColumn,
              !darkBackground && c.lightHeader
            )}
            {...pageHeaderData}
          />
          {!background && (
            <PageHeaderImagesSection
              currentImages={currentImages}
              isShowcasePage={isShowcasePage}
              isFeaturePage={isFeaturePage}
              isDirectMailPage={isDirectMailPage}
              isPaymentsPage={isPaymentsPage}
              includeWave={includeWave}
              label={label}
            />
          )}
        </div>
        {includeWave && <PageHeaderWaveBackground backgroundImage={background || darkBackground} />}
      </section>
    </div>
  );
};
